import { render, staticRenderFns } from "./AddTpcdModal.vue?vue&type=template&id=8e74568a&"
import script from "./AddTpcdModal.vue?vue&type=script&lang=js&"
export * from "./AddTpcdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports